import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthCard from "@/components/auth/AuthCard";
import AuthButton from "@/components/auth/AuthButton";
import { useAuth, formatAuthError } from "@/context/AuthContext";
import { useState } from "react";

// Subscription — Manage the Premium subscription. Only reachable when
// `user.premium_plan` is truthy; anyone else is bounced to Home to
// prevent a Trial user from accidentally acquiring `basic_owned=true`
// by clicking the cancel button.
export default function Subscription() {
  const { user, selectPlan } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!user?.premium_plan) {
    return <Navigate to="/" replace />;
  }

  const onCancel = async () => {
    setBusy(true);
    try {
      await selectPlan(true, null);
      toast("Premium subscription cancelled", {
        description: "You are now on Basic. No refunds are provided for unused time.",
      });
      navigate("/settings", { replace: true });
    } catch (err) {
      toast.error(formatAuthError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard
      title="Manage Subscription"
      subtitle="Your Premium subscription is active."
    >
      <p className="text-xs vp-muted mb-6" data-testid="subscription-body">
        Canceling your Premium subscription will return you to Basic immediately. No refunds are provided for unused time.
      </p>
      <AuthButton
        onClick={onCancel}
        testid="subscription-cancel-premium"
        loading={busy}
      >Cancel Premium Subscription</AuthButton>
      <div className="mt-3">
        <AuthButton
          variant="charcoal"
          onClick={() => navigate("/")}
          testid="subscription-back"
        >Back</AuthButton>
      </div>
    </AuthCard>
  );
}
